<template>
  <div class="invoice">
    <div>
      <h4 class="title-color">New Permit Fee Invoice</h4>
    </div>
    <div class="form-row">
      <div class="form-row-input required-label" style="width: 33%;">
        <scc-input-validator :rules="[requiredRule]" :value="invoice.applicationRequest.productId"
            @validate="(v) => (this.isTypeValid = v)">
          <ejs-dropdownlist float-label-type="Always" :dataSource='productsList'
            :fields="{ value: 'productId', text: 'productName' }" :change="onProductSelection"
            placeholder='Application Type:' v-model="invoice.applicationRequest.productId">
          </ejs-dropdownlist>
        </scc-input-validator>
      </div>
      <div class="form-row-input" style="width: 40%;">
        <ejs-textbox float-label-type="Always" placeholder="Reference/PO#:"
          v-model="invoice.referencePO" />
      </div>
    </div>
    <div v-show="!isOperatingPermit" class="form-row">
      <div class="form-row-input align-content" style="width: 20%; display: flex;
          flex-direction: row; gap: 10px">
        <ejs-radiobutton ref="permit" name="isPermit" label="Permit"
          :checked="invoice.applicationRequest.isPermit" @change="isSiteOrPermit" />
        <ejs-radiobutton ref="site" label="Site" name="isPermit"
          :checked="!invoice.applicationRequest.isPermit"
          @change="isSiteOrPermit" />
      </div>
      <div v-show="invoice.applicationRequest.isPermit" class="form-row-input required-label"
        style="width: 33%;">
        <scc-input-validator :rules="[requiredRule]" :value="invoice.applicationRequest.permitNo"
            @validate="(v) => (this.isPermitValid = v)">
          <ejs-autocomplete ref="permitNumAutocomplete" :dataSource="permitList"
            placeholder="Permit Number:" :minLength="3"
            :fields="{ value: 'permitDisplayText', text: 'permitDisplayText' }"
            :change="onPermitSelection" float-label-type="Always"
            v-model="invoice.applicationRequest.permitNo">
          </ejs-autocomplete>
        </scc-input-validator>
      </div>
      <div v-show="!invoice.applicationRequest.isPermit" style="width: 33%;"
        class="form-row-input required-label">
        <scc-input-validator :rules="[requiredRule]" :value="invoice.applicationRequest.siteName"
            @validate="(v) => (this.isSiteValid = v)">
          <ejs-autocomplete ref="siteNumberAutocomplete" :dataSource="siteList"
            placeholder="Site Number:" :fields="{ value: 'siteName', text: 'siteName' }"
            :minLength="3" :change="onSiteChange" float-label-type="Always"
            v-model="invoice.applicationRequest.siteName">
          </ejs-autocomplete>
        </scc-input-validator>
      </div>
      <div v-if="invoice.applicationRequest.isPermit" class="form-row-input"
        style="width: 40%;">
        <ejs-textbox float-label-type="Always" placeholder="Site Name:"
          v-model="invoice.applicationRequest.siteName" :readonly="true" />
      </div>
    </div>
    <div v-show="isOperatingPermit" class="form-row">
      <div class="form-row-input required-label" style="width: 33%;">
        <scc-input-validator :rules="[requiredRule]"
        :value="invoice.applicationRequest.selectedOwner"
            @validate="(v) => (this.isOwnerValid = v)">
          <ejs-autocomplete ref="siteOwnerAutocomplete" :dataSource="ownerList"
            placeholder="Site Owner/Site Contact:" float-label-type="Always"
            :fields="{ value: 'ownerDisplayText', text: 'ownerDisplayText' }"
            :minLength="3" :change="onSiteOwnerChange"
            v-model="invoice.applicationRequest.selectedOwner">
          </ejs-autocomplete>
        </scc-input-validator>
      </div>
    </div>
    <div class="form-row">
      <div class="form-row-input" style="width: 100%; display: flex;
        flex-direction: row; gap: 10px">
        <label class="label-text required-css">Bill Invoice To:</label>
        <ejs-radiobutton ref="owner" name="isApplicant"
          label="Site Owner/Site Contact" :value="false"
          :checked="!invoice.applicationRequest.misIsApplicant" @change="isOwnerOrApplicant()" />
        <div v-if="!isOperatingPermit && invoice.applicationRequest.isPermit">
          <ejs-radiobutton ref="applicant" label="Applicant"
          name="isApplicant" :checked="invoice.applicationRequest.misIsApplicant" :value="true"
          @change="isOwnerOrApplicant()" />
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-row-input" style="width: 49%;">
        <fieldset>
          <legend>
            <h5 class="title-color" style="margin: 0px;">Site Owner/Site Contact Details</h5>
          </legend>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">Number: {{ invoice.applicationRequest.ownerId }}</label>
            </div>
          </div>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">
                Company: {{ invoice.applicationRequest.ownerCompanyName }}</label>
            </div>
          </div>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">Contact: {{ invoice.applicationRequest.ownerName }}</label>
            </div>
          </div>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">Address: {{ invoice.applicationRequest.ownerAddress }}
              </label>
            </div>
          </div>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">Email:<span
                v-show="!invoice.applicationRequest.misIsApplicant"
                class="required-css"></span> {{ invoice.applicationRequest.ownerEmailAddress }}
              </label>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="form-row-input" style="width: 49%;">
        <fieldset>
          <legend>
            <h5 class="title-color" style="margin: 0px;">Applicant Details</h5>
          </legend>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">Company:
              <span v-show="invoice.applicationRequest.isPermit">{{invoice.applicationRequest.applicantCompanyName}}</span>
              </label>
            </div>
          </div>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">
                Contact: 
                <span v-show="invoice.applicationRequest.isPermit">{{ invoice.applicationRequest.applicantName }}</span>
                </label>
            </div>
          </div>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">
                Address: 
                <span v-show="invoice.applicationRequest.isPermit">{{ invoice.applicationRequest.applicantCompanyAddress }}</span>
              </label>
            </div>
          </div>
          <div class="form-row">
            <div class="form-row-input">
              <label class="label-text">
                Email:<span v-show="invoice.applicationRequest.misIsApplicant"
                class="required-css"></span> 
                <span v-show="invoice.applicationRequest.isPermit">{{ invoice.applicationRequest.applicantEmailAddress }}</span>
              </label>
            </div>
          </div>
          <!-- Added empty space to maintain the details design  -->
          <div class="form-row">
            <div class="form-row-input">
              &nbsp;
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <div class="form-row">
      <div class="form-row-input" style="width: 99%">
        <ejs-textbox float-label-type="Always" placeholder="Internal Comments:"
          v-model="invoice.applicationRequest.internalNotes" multiline="true" rows=2 />
      </div>
    </div>
    <div class="form-row">
      <div class="form-row-input required-label" style="width: 99%">
        <scc-input-validator :rules="[requiredRule]"
          :value="invoice.applicationRequest.externalNotes"
          @validate="(v) => (this.isDescValid = v)">
          <ejs-textbox float-label-type="Always" placeholder="Description:"
            v-model="invoice.applicationRequest.externalNotes" multiline="true"
            :maxlength="500" rows=2 />
        </scc-input-validator>
      </div>
    </div>
    <div>
      <fieldset>
        <legend>
          <h5 class="title-color" style="margin: 0px;">Product Details</h5>
        </legend>
        <div v-show="!isOperatingPermit || isNewItem">
          <div class="form-row">
            <div v-if="isNewItem" class="form-row-input required-label" style="width: 25%;">
              <scc-input-validator :rules="[requiredRule]" :value="productDetails.tmsRegistrationId"
                @validate="(v) => (this.isPeriodValid = v)">
                <ejs-dropdownlist float-label-type="Always" :dataSource='opFeeList'
                  :fields="{ value: 'registrationID', text: 'registrationDesc' }"
                  placeholder='Registration Period:' v-model="productDetails.tmsRegistrationId"
                  :change="onPeriodChange">
                </ejs-dropdownlist>
              </scc-input-validator>
            </div>
            <div v-if="isNewItem" class="form-row-input required-label" style="width: 50%;">
              <scc-input-validator :rules="[requiredRule]" :value="productDetails.siteName"
                @validate="(v) => (this.isSiteNameValid = v)">
                <ejs-dropdownlist float-label-type="Always" :dataSource='ownerSiteList'
                  :fields="{ value: 'siteName', text: 'siteName' }"
                  placeholder='Site Number:' v-model="productDetails.siteName"
                  :change="onSiteSelected">
                </ejs-dropdownlist>
              </scc-input-validator>
            </div>
            <div style="width:25%;" class="form-row-input">
              <ejs-numerictextbox float-label-type="Always" placeholder="Fee Total:" format="C2"
                v-model="productDetails.regFee" :showSpinButton="false" :min="0"
                :change="onFeeChange"/>
            </div>
            <div style="width:25%;" class="form-row-input">
              <ejs-numerictextbox float-label-type="Always" placeholder="Levy Total:" format="C2"
                v-model="productDetails.sccFee" :showSpinButton="false" :min="0"
                :change="onFeeChange"/>
            </div>
            <div style="width:25%;" class="form-row-input required-label">
              <scc-input-validator :rules="[requiredRule]" :value="productDetails.misTanksAmount"
                @validate="(v) => (this.isTankValid = v)">
                <ejs-numerictextbox float-label-type="Always"
                placeholder="Tanks:" format="N" :change="onTankAmtChange"
                :showSpinButton='false' v-model="productDetails.misTanksAmount " />
              </scc-input-validator>
            </div>
          </div>
          <div v-if="isOperatingPermit" class="form-row">
            <div style="width: 100%" class="align-right">
              <ejs-button type="submit" cssClass="e-info margin-button"
                v-on:click.native="onAddClick()">Add</ejs-button>
              <ejs-button type="button" cssClass="e-info margin-button"
                v-on:click.native="onCancelAddClick()">Cancel</ejs-button>
            </div>
          </div>
        </div>
        <div v-show="isOperatingPermit && !isNewItem">
          <div class="form-row-input align-right" style="width: 100%">
            <ejs-button type="button" cssClass="e-link" v-on:click.native="onAddNewLineItemClick()">
              <font-awesome-icon :icon="['fas', 'plus']" style="display: inline" />
              Add New Line Item
            </ejs-button>
          </div>
          <ejs-grid style="max-height: 200px; overflow-y: auto;" :dataSource="selectedProductList"
            ref="refProductList" :created="created" :enablePersistence="false"
            :selection-settings="selectionOptions" :commandClick="commandClick"
            :allowSorting="true" :allowPaging="true" :pageSettings="pageSettings">
            <e-columns>
              <e-column :template='cTemplate' width="5%" headerText="#" textAlign="Left" />
              <e-column field="siteName" width="45%" headerText="Site"
                textAlign="Left" />
              <e-column field="regFee" width="10%" headerText="Fee" textAlign="Left" />
              <e-column field="sccFee" width="10%" headerText="Levy" textAlign="Left"/>
              <e-column field="misTanksAmount" width="10%" headerText="Tanks" textAlign="Left" />
              <e-column field="totalFee" width="10%" headerText="Total" textAlign="Left" />
              <e-column headerText="Delete" width="10%"
                :commands="deleteCommand" textAlign="Left" />
            </e-columns>
          </ejs-grid>
        </div>
      </fieldset>

      <div class="form-row">
        <div class="form-row-input" style="width: 99%">
          <label class="label-text">Total Due: ${{ invoice.applicationRequest.totalAmount }}</label>
        </div>
      </div>
      <div class="form-row">
        <div style="width: 100%" class="align-right">
          <ejs-button type="button" cssClass="e-info margin-button"
            v-on:click.native="onResetClick()">Reset Form</ejs-button>
          <ejs-button type="submit" cssClass="e-info margin-button"
            v-on:click.native="onSaveClick()">Save</ejs-button>
          <ejs-button type="button" cssClass="e-info margin-button"
            v-on:click.native="onCancelClick()">Cancel</ejs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { TextBoxPlugin, NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { RadioButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { DropDownListPlugin, AutoCompletePlugin } from '@syncfusion/ej2-vue-dropdowns';
import { mapGetters } from 'vuex';
import { DialogUtility } from '@syncfusion/ej2-popups';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
} from "@syncfusion/ej2-vue-grids";
import {
  GET_OPEN_PERMITS, GET_PRODUCTS_TYPE_LIST,
  GET_PRICE_BY_PRODUCTID, SET_INVOICE,
  GET_OP_FEE,
} from '../store';

import { SET_SELECTED_USER } from "../../reports/store";
import SccInputValidator from '../../../components/base/scc-input-new-validator.vue';

Vue.use(TextBoxPlugin);
Vue.use(RadioButtonPlugin);
Vue.use(AutoCompletePlugin);
Vue.use(DropDownListPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(GridPlugin);

export default {
  name: "AdditionalFeeInvoice",
  components: {
    SccInputValidator,
  },
  data() {
    return {
      requiredRule: {
        regEx: '^(?!\\s*$).+',
        message: 'This field is required',
      },
      isTypeValid: false,
      isPermitValid: false,
      isPeriodValid: false,
      isSiteNameValid: false,
      isSiteValid: false,
      isOwnerValid: false,
      isClosedPermit: false,
      isTankValid: true,
      isDescValid: false,
      cTemplate() {
        return {
          template: Vue.component('columnTemplate', {
            template: `<b> {{index}} </b>`,
            data() {
              return {
                data: {},
              };
            },
            computed: {
              index() {
                return (parseInt(this.data.index, 10) + 1);
              },
            },
          }),
        };
      },
      isOperatingPermit: false,
      isNewItem: false,
      opFeeList: [],
      ownerSiteList: [],
      siteList: [],
      selectionOptions: {
        type: "Single",
        enableSimpleMultiRowSelection: false,
        enableToggle: true,
        persistSelection: true,
      },
      pageSettings: { pageSize: 10 },
      deleteCommand: [
        {
          type: "Delete",
          buttonOption: {
            cssClass: 'e-flat deletebtn',
            iconCss: 'e-delete e-icons',
          },
        },
      ],
      selectedPermit: null,
      invoice: {
        invoiceSourceType: 'Additional Invoice',
        referencePO: null,
        applicationRequest: {
          productId: null,
          requestUserEmail: null,
          requestor: null,
          firstName: null,
          lastName: null,
          isPermit: true,
          permitID: null,
          applicantName: null,
          applicantCompany: null,
          ownerNumber: null,
          ownerName: null,
          internalNotes: null,
          externalNotes: null,
          totalAmount: 0.00,
          requestType: 'Additional Invoice',
          misIsApplicant: false,
          selectedOwner: null,
          permitNo: null,
          municipality: null,
        },
        invoiceDetails: [],
      },
      productDetails: {
        fee: 0.00,
        levy: 0.00,
        tmsRegistrationId: null,
        regFee: 0.00,
        sccFee: 0.00,
        siteID: null,
        siteName: null,
        siteAddress: null,
        misTanksAmount: 1,
        misTmsPermitId: null,
        misTmsPermitNo: null,
        registrationYear: null,
        totalFee: 0,
      },
      dialogObj: null,
      ownerList: [],
      permitList: [],
      selectedProductList: [],
      spin: false,
    };
  },
  computed: {
    ...mapGetters({
      openPermits: 'openPermits',
      productsList: 'products',
    }),
  },
  methods: {
    async created() {
      await this.getOpenPermitList();
      await this.getProductsList();
    },
    async getOpenPermitList() {
      try {
        const openPermits = await this.$store.dispatch(GET_OPEN_PERMITS, null);
        this.getUniqueData(openPermits.data);
      } catch (err) {
        console.error(err);
      }
    },
    getUniqueData(data) {
      if (data) {
        // eslint-disable-next-line array-callback-return
        data.map((permit) => {
          const currentData = permit;
          const ownerDisplayText = ` ${permit.ownerID} - ${permit.ownerName ?? ''}, ${permit.ownerEmailAddress ?? ''}`;
          const permitDisplayText = `${permit.permitNo ?? ''} (${permit.permitID})`;
          const ownerIndex = this.ownerList.findIndex((item) => item.ownerID && permit.ownerID
            && item.ownerID === permit.ownerID
            && item.ownerContactID === permit.ownerContactID);

          if (ownerIndex < 0) {
            currentData.ownerDisplayText = ownerDisplayText;
            currentData.permitDisplayText = permitDisplayText;
            currentData.ownerSiteList = [{
              siteID: permit.siteID,
              siteName: permit.siteName,
              siteAddress: permit.siteAddress,
            }];
            this.ownerList.push(currentData);
          } else
          // eslint-disable-next-line max-len
          if (this.ownerList[ownerIndex].ownerSiteList.findIndex((item) => item.siteID === permit.siteID) < 0) {
            this.ownerList[ownerIndex].ownerSiteList.push({
              siteID: permit.siteID,
              siteName: permit.siteName,
              siteAddress: permit.siteAddress,
            });
          }

          // eslint-disable-next-line max-len
          if (permit.permitID && (this.permitList.findIndex((item) => item.permitID === permit.permitID) < 0)) {
            currentData.ownerDisplayText = ownerDisplayText;
            currentData.permitDisplayText = permitDisplayText;
            this.permitList.push(currentData);
          }

          // eslint-disable-next-line max-len
          if (permit.siteID && (this.siteList.findIndex((item) => item.siteID === permit.siteID) < 0)) {
            currentData.ownerDisplayText = ownerDisplayText;
            currentData.permitDisplayText = permitDisplayText;
            this.siteList.push(currentData);
          }
        });
      }
    },
    async getProductsList() {
      try {
        await this.$store.dispatch(GET_PRODUCTS_TYPE_LIST);
      } catch (err) {
        console.error(err);
      }
    },
    async getPriceByProductID(productId) {
      let priceDetails = null;
      try {
        priceDetails = await this.$store.dispatch(GET_PRICE_BY_PRODUCTID, productId);
      } catch (err) {
        console.error(err);
      }
      return priceDetails;
    },
    async getOPFeeList() {
      try {
        this.opFeeList = await this.$store.dispatch(GET_OP_FEE, null);
      } catch (err) {
        console.error(err);
      }
    },
    notify(type, message) {
      this.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
    validateInvoice() {
      this.invoice.applicationRequest.productId = !this.invoice.applicationRequest.productId
        ? '' : this.invoice.applicationRequest.productId;
      this.invoice.applicationRequest.externalNotes = !this.invoice.applicationRequest.externalNotes
        ? '' : this.invoice.applicationRequest.externalNotes;

      if (this.isOperatingPermit) {
        this.isPermitValid = true;
        this.isSiteValid = true;
        // eslint-disable-next-line max-len
        this.invoice.applicationRequest.selectedOwner = !this.invoice.applicationRequest.ownerId
          ? '' : this.invoice.applicationRequest.selectedOwner;
      } else {
        this.isOwnerValid = true;
        this.productDetails.misTanksAmount = !this.productDetails.misTanksAmount
          ? '' : this.productDetails.misTanksAmount;
        if (this.invoice.applicationRequest.isPermit) {
          this.isSiteValid = true;
          this.invoice.applicationRequest.permitNo = !this.invoice.applicationRequest.permitID
            ? '' : this.invoice.applicationRequest.permitNo;
        } else {
          this.isPermitValid = true;
          this.invoice.applicationRequest.siteName = !this.invoice.applicationRequest.siteID
            ? '' : this.invoice.applicationRequest.siteName;
        }
      }
    },
    validateProduct() {
      this.productDetails.tmsRegistrationId = !this.productDetails.tmsRegistrationId
        ? '' : this.productDetails.tmsRegistrationId;

      this.productDetails.siteName = !this.productDetails.siteName
        ? '' : this.productDetails.siteName;

      this.productDetails.misTanksAmount = !this.productDetails.misTanksAmount
        ? '' : this.productDetails.misTanksAmount;
    },
    isOwnerOrApplicant() {
      this.invoice.applicationRequest.misIsApplicant = this.$refs.applicant?.$el.checked;
      this.ownerOrApplicantChange();
    },
    ownerOrApplicantChange() {
      if (this.invoice.applicationRequest.misIsApplicant) {
        // eslint-disable-next-line max-len
        this.invoice.applicationRequest.requestUserEmail = this.selectedPermit?.applicantEmailAddress ?? null;
        this.invoice.applicationRequest.requestor = this.selectedPermit?.applicantName ?? null;
        this.invoice.applicationRequest.firstName = this.selectedPermit?.applicantFirstName ?? null;
        this.invoice.applicationRequest.lastName = this.selectedPermit?.applicantLastName ?? null;
        this.invoice.applicationRequest.company = this.selectedPermit?.applicantCompanyName ?? null;
        // eslint-disable-next-line max-len
        this.invoice.applicationRequest.billingAddress = this.selectedPermit?.applicantCompanyAddress ?? null;
        this.invoice.applicationRequest.city = this.selectedPermit?.applicantCityName ?? null;
        // eslint-disable-next-line max-len
        this.invoice.applicationRequest.province = this.selectedPermit?.applicantProvinceName ?? null;
        // eslint-disable-next-line max-len
        this.invoice.applicationRequest.postalCode = this.selectedPermit?.applicantPostalCode ?? null;
      } else {
        // eslint-disable-next-line max-len
        this.invoice.applicationRequest.requestUserEmail = this.selectedPermit?.ownerEmailAddress ?? null;
        this.invoice.applicationRequest.requestor = this.selectedPermit?.ownerName ?? null;
        this.invoice.applicationRequest.firstName = this.selectedPermit?.ownerFirstName ?? null;
        this.invoice.applicationRequest.lastName = this.selectedPermit?.ownerLastName ?? null;
        this.invoice.applicationRequest.company = this.selectedPermit?.ownerCompanyName ?? null;
        this.invoice.applicationRequest.billingAddress = this.selectedPermit?.ownerAddress ?? null;
        this.invoice.applicationRequest.city = this.selectedPermit?.ownerCityName ?? null;
        this.invoice.applicationRequest.province = this.selectedPermit?.ownerProvinceName ?? null;
        this.invoice.applicationRequest.postalCode = this.selectedPermit?.ownerPostalCode ?? null;
      }

      if (this.selectedPermit && !this.invoice.applicationRequest.requestUserEmail) {
        this.notify('Error', 'Please make sure owner/applicant has a valid email.');
      }
    },
    isSiteOrPermit() {
      this.invoice.applicationRequest.isPermit = this.$refs.permit.$el.checked;
      if (!this.invoice.applicationRequest.isPermit
          && this.invoice.applicationRequest.misIsApplicant) {
        this.invoice.applicationRequest.misIsApplicant = false;
      }
      this.resetInvoice(false, false);
    },
    onSiteChange(e) {
      if (e && e.e) {
        this.setDetails(e.itemData);
      } else if (e?.e === undefined) {
        this.setDetails(null);
      }
    },
    onSiteOwnerChange(e) {
      if (e && e.e) {
        this.setDetails(e.itemData);
      } else if (e?.e === undefined) {
        this.setDetails(null);
      }
    },
    onPermitSelection(e) {
      if (e && e.e) {
        this.setDetails(e.itemData);
      } else if (e?.e === undefined) {
        this.setDetails(null);
      }
    },
    setDetails(permit) {
      this.isClosedPermit = false;
      if (permit?.permitStatusType?.toLowerCase() === 'closed') {
        this.isClosedPermit = true;
        this.notify('Error', 'Permit fees cannot be added to a closed permit.');
        // eslint-disable-next-line no-param-reassign
        permit = null;
      }

      this.selectedPermit = permit;
      this.invoice.applicationRequest.selectedOwner = permit?.ownerDisplayText ?? null;
      this.ownerSiteList = permit?.ownerSiteList?.sort((a, b) => a.siteID - b.siteID) ?? [];
      this.ownerOrApplicantChange();
      this.setOwnerAndApplicantDetails(permit);
    },
    setOwnerAndApplicantDetails(permit) {
      this.invoice.applicationRequest.applicantName = permit?.applicantName ?? null;
      this.invoice.applicationRequest.applicantEmailAddress = permit?.applicantEmailAddress ?? null;
      // eslint-disable-next-line max-len
      this.invoice.applicationRequest.applicantCompanyAddress = permit?.applicantCompanyAddress ?? null;
      this.invoice.applicationRequest.applicantCompanyName = permit?.applicantCompanyName ?? null;
      this.invoice.applicationRequest.ownerNumber = permit?.ownerContactID ?? null;
      this.invoice.applicationRequest.ownerName = permit?.ownerName ?? null;
      this.invoice.applicationRequest.ownerAddress = permit?.ownerAddress ?? null;
      this.invoice.applicationRequest.ownerId = permit?.ownerID ?? null;
      this.invoice.applicationRequest.ownerContactId = permit?.ownerContactID ?? null;
      this.invoice.applicationRequest.ownerEmailAddress = permit?.ownerEmailAddress ?? null;
      this.invoice.applicationRequest.ownerCompanyName = permit?.ownerCompanyName ?? null;
      this.invoice.applicationRequest.siteID = permit?.siteID ?? null;
      this.invoice.applicationRequest.siteName = permit?.siteName ?? null;
      this.invoice.applicationRequest.siteAddress = permit?.siteAddress ?? null;
      this.invoice.applicationRequest.permitID = permit?.permitID ?? null;
      this.invoice.applicationRequest.permitNo = permit?.permitNo ?? null;
      this.invoice.applicationRequest.municipality = permit?.municipalityName ?? null;
      if (!this.isOperatingPermit) {
        this.productDetails.siteID = this.invoice.applicationRequest.siteID;
        this.productDetails.siteName = this.invoice.applicationRequest.siteName;
        // eslint-disable-next-line max-len
        this.productDetails.siteAddress = this.invoice.applicationRequest.siteAddress;
        this.productDetails.misTmsPermitNo = this.invoice.applicationRequest.permitNo;
        this.productDetails.misTmsPermitId = this.invoice.applicationRequest.permitID;
      }
    },
    onAddNewLineItemClick() {
      this.validateInvoice();
      if (this.isOwnerValid) {
        this.isNewItem = true;
      } else {
        this.notify('Error', 'Please fill out required fields and try again.');
      }
    },
    onProductSelection(e) {
      if (this.isOperatingPermit) {
        this.onCancelAddClick();
      }
      this.invoice.applicationRequest.totalAmount = 0.00;
      this.isNewItem = false;
      this.selectedProductList = [];
      const product = e && e.e && e.itemData;
      switch (product?.productCode) {
        case 'STSOP':
          this.setDetails(null);
          this.isOperatingPermit = true;
          this.invoice.applicationRequest.misIsApplicant = false;
          this.onCancelAddClick();
          this.getOPFeeList();
          break;
        case 'STSRP':
        case 'STSRWP':
        case 'STSWP':
          if (this.isOperatingPermit) {
            this.setDetails(null);
          }
          this.isOperatingPermit = false;
          this.getPriceDetails();
          break;
        default:
          this.isOperatingPermit = false;
          break;
      }
    },
    async getPriceDetails() {
      if (this.invoice.applicationRequest.productId) {
        // eslint-disable-next-line max-len
        const priceDetails = await this.getPriceByProductID(this.invoice.applicationRequest.productId);
        if (priceDetails) {
          this.productDetails.fee = priceDetails?.amountApp;
          this.productDetails.levy = priceDetails?.amountLevy;
          this.onTankAmtChange();
          this.onFeeChange();
        }
      }
    },
    onTankAmtChange() {
      this.productDetails.regFee = this.productDetails.fee * this.productDetails.misTanksAmount;
      this.productDetails.sccFee = this.productDetails.levy * this.productDetails.misTanksAmount;
      this.onFeeChange();
    },
    onFeeChange() {
      if (!this.isOperatingPermit) {
        this.invoice.applicationRequest.totalAmount = this.productDetails.regFee
          + this.productDetails.sccFee;
      }
    },
    onPeriodChange(e) {
      const data = e && e.e && e.itemData;
      this.productDetails.fee = data.fee12Month ?? 0;
      this.productDetails.levy = data.feeSCC ?? 0;
      this.onTankAmtChange();
      this.productDetails.registrationYear = new Date(data.fromDate).getUTCFullYear();
    },
    onSiteSelected(e) {
      const site = e && e.e && e.itemData;
      this.productDetails.siteID = site?.siteID ?? null;
      this.productDetails.siteName = site?.siteName ?? null;
      this.productDetails.siteAddress = site?.siteAddress ?? null;
    },
    onAddClick() {
      this.validateProduct();
      const isValid = this.isPeriodValid && this.isSiteNameValid && this.isTankValid;
      if (isValid) {
        this.productDetails.totalFee = this.productDetails.regFee
          + this.productDetails.sccFee;
        this.selectedProductList.push(this.productDetails);
        this.invoice.applicationRequest.totalAmount += this.productDetails.totalFee;

        this.$refs.refProductList.refresh();
        this.onCancelAddClick();
      } else {
        this.notify('Error', 'Please fill out required product details and try again.');
      }
    },
    onCancelAddClick() {
      this.isNewItem = false;
      this.isPeriodValid = false;
      this.isSiteNameValid = false;
      this.isTankValid = true;
      this.productDetails = {
        tmsRegistrationId: null,
        fee: 0.00,
        levy: 0.00,
        regFee: 0.00,
        sccFee: 0.00,
        siteID: null,
        siteName: null,
        siteAddress: null,
        misTanksAmount: 1,
        misTmsPermitId: null,
        misTmsPermitNo: null,
        registrationYear: null,
        totalFee: 0,
      };
    },
    async onSaveClick() {
      this.validateInvoice();
      if (this.isClosedPermit) {
        this.notify('Error', 'Permit fees cannot be added to a closed permit. If Permit fees need to be added to a closed permit, the permit MUST be reopened first.');
      } else if (this.selectedPermit && !this.invoice.applicationRequest.requestUserEmail) {
        this.notify('Error', 'Please add a valid email to owner/applicant and try adding the invoice again...');
      } else {
        let isValid = this.isTypeValid && this.isPermitValid && this.isSiteValid
          && this.isOwnerValid && this.isDescValid;
        if (!this.isOperatingPermit) {
          isValid = isValid && this.isTankValid;
        }
        if (isValid) {
          try {
            let invoiceDetails = [];
            if (!this.isOperatingPermit) {
              invoiceDetails = [{
                regFee: this.productDetails.regFee,
                sccFee: this.productDetails.sccFee,
                siteID: this.productDetails.siteID,
                siteName: this.productDetails.siteName,
                siteAddress: this.productDetails.siteAddress,
                misTanksAmount: this.productDetails.misTanksAmount,
                misTmsPermitId: this.productDetails.misTmsPermitId,
                misTmsPermitNo: this.productDetails.misTmsPermitNo,
              }];
            } else {
              invoiceDetails = this.selectedProductList.map((p) => ({
                tmsRegistrationId: p.tmsRegistrationId,
                regFee: p.regFee,
                sccFee: p.sccFee,
                siteID: p.siteID,
                siteName: p.siteName,
                siteAddress: p.siteAddress,
                misTanksAmount: p.misTanksAmount,
                registrationYear: p.registrationYear,
              }));
            }

            if (invoiceDetails?.length > 0) {
              this.invoice.invoiceDetails = invoiceDetails;
              const data = JSON.parse(JSON.stringify(this.invoice));
              await this.$store.dispatch(SET_INVOICE, { data });
              this.notify('Success!', 'Invoice created successfully.');
              await this.$store.commit(SET_SELECTED_USER, {
                selectedUser: {
                  email: this.invoice.applicationRequest.requestUserEmail,
                  ownerContactId: this.invoice.applicationRequest.ownerContactId,
                  ownerId: this.invoice.applicationRequest.ownerId,
                  userFullName: this.invoice.applicationRequest.requestor,
                },
              });
              this.$router.push('/reports/transactions');
            } else {
              this.notify('Error', 'Please provide product details.');
            }
          } catch (err) {
            this.notify('Error', err.response.data.message);
          }
        } else {
          this.notify('Error', 'Please fill out required fields and try again.');
        }
      }
    },
    onCancelClick() {
      this.confirmCancel(false);
    },
    onResetClick() {
      this.confirmCancel(true);
    },
    resetInvoice(isButtonClick = true, resetProduct = true) {
      this.onCancelAddClick();
      this.isClosedPermit = false;
      this.isSiteValid = false;
      this.isPermitValid = false;
      this.isOwnerValid = false;
      this.isDescValid = false;
      this.invoice.referencePO = null;
      if (isButtonClick) {
        this.invoice.applicationRequest.misIsApplicant = false;
      }
      this.invoice.applicationRequest.permitNo = null;
      this.invoice.applicationRequest.siteName = null;
      this.invoice.applicationRequest.internalNotes = null;
      this.invoice.applicationRequest.externalNotes = null;
      this.selectedPermit = null;
      this.ownerOrApplicantChange();
      this.setOwnerAndApplicantDetails(null);
      this.selectedProductList = [];
      this.invoice.applicationRequest.totalAmount = 0.00;
      if (resetProduct) {
        this.invoice.applicationRequest.productId = null;
        this.isTypeValid = false;
      } else {
        this.getPriceDetails();
      }
    },
    confirmCancel(isReset = false) {
      if (this.isTypeValid || this.isDescValid || this.selectedPermit
        || this.selectedProductList.length > 0) {
        this.dialogObj = DialogUtility.confirm({
          title: 'Cancel Confirmation',
          content: 'All previously entered data will be lost. Are you sure you want to proceed?',
          okButton: { text: 'OK', click: this.cancelInvoice.bind(this, isReset) },
          cancelButton: { text: 'Cancel', click: this.hideDialog },
          showCloseIcon: true,
          closeOnEscape: true,
          animationSettings: { effect: 'Zoom' },
        });
      } else if (isReset) {
        this.resetInvoice(isReset);
      } else {
        this.$router.push('/reports/transactions');
      }
    },
    cancelInvoice(isReset) {
      this.resetInvoice(isReset);
      this.dialogObj.hide();
      if (!isReset) {
        this.$router.push('/reports/transactions');
      }
    },
    commandClick(args) {
      switch (args.commandColumn.type) {
        case 'Delete':
          this.dialogObj = DialogUtility.confirm({
            title: 'Delete Line Item',
            content: 'Are you sure you want to delete this line item?',
            okButton: { text: 'OK', click: this.deleteLineItem.bind(this, args) },
            cancelButton: { text: 'Cancel', click: this.hideDialog },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Zoom' },
          });
          break;
        default:
          break;
      }
    },
    deleteLineItem(args) {
      const index = this.selectedProductList.indexOf(args.rowData);
      if (index >= 0) {
        this.selectedProductList.splice(index, 1);
        this.invoice.applicationRequest.totalAmount -= args.rowData.totalFee;
        this.notify('Success!', 'Item deleted successfully.');
        this.$refs.refProductList.refresh();
      }
      this.hideDialog();
    },
    hideDialog() {
      this.dialogObj.hide();
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search],
  },
};
</script>
<style>
@import '../../../assets/styles/eservices-base.css';

.pt-15 {
  padding-top: 15px;
}

.label-text {
  font-size: 13px;
  font-weight: 400;
}

.invoice .form-row-input {
  padding-right: 15px;
}

</style>
